import React from 'react';

import i18n from 'i18n-js';
import Layout from 'components/Layout';
import { useParams } from 'react-router-dom';
import useStyles from './InvoicePage.styled';
import { Container } from '@material-ui/core';
import { InvoicePreview } from 'components/Invoice';

const InvoicePage = (props) => {
  const { isBill } = props;
  const classes = useStyles();
  const { id } = useParams();

  return (
    <Layout title={isBill ? i18n.t('bill.title') : i18n.t('invoice.title')}>
      <Container className={classes.container}>
        <InvoicePreview id={id} {...props} />
      </Container>
    </Layout>
  );
};

export { InvoicePage };
